module.exports = __webpack_public_path__ + "static/media/_MG_6295.63c0a334.jpg";